// Fires a best-effort Slack notification when a Nimbo download is requested.
//
// NOTE: This runs in the visitor's browser, so the webhook URL is embedded in
// the built JS bundle and is therefore publicly visible. That is an accepted
// trade-off for a no-backend setup. If abuse becomes a problem, rotate the
// webhook or move this relay server-side. Requests are also best-effort:
// ad blockers / privacy extensions may block calls to hooks.slack.com, so
// treat Google Analytics as the source of truth for exact download counts.

const WEBHOOK_URL = process.env.REACT_APP_SLACK_WEBHOOK_URL?.trim();

export const notifyDownload = (build) => {
  if (!WEBHOOK_URL || typeof window === 'undefined') {
    return;
  }

  try {
    const when = new Date().toLocaleString('en-US', {
      timeZone: 'America/Cancun',
      dateStyle: 'medium',
      timeStyle: 'short',
    });
    const referrer = (typeof document !== 'undefined' && document.referrer) || 'direct';
    const agent = (typeof navigator !== 'undefined' && navigator.userAgent) || 'unknown';

    const payload = {
      text: `:inbox_tray: Nimbo download — ${build}`,
      blocks: [
        {
          type: 'section',
          text: { type: 'mrkdwn', text: `:inbox_tray: *Nimbo download requested* — *${build}*` },
        },
        {
          type: 'context',
          elements: [
            { type: 'mrkdwn', text: `*When:* ${when} (Cancún)` },
            { type: 'mrkdwn', text: `*Referrer:* ${referrer}` },
            { type: 'mrkdwn', text: `*Page:* ${window.location.href}` },
            { type: 'mrkdwn', text: `*Agent:* ${agent}` },
          ],
        },
      ],
    };

    // Slack webhooks reject a JSON `Content-Type` from the browser (CORS
    // preflight), so we send the payload form-encoded as `payload=<json>` —
    // a CORS-safe content type that triggers no preflight and that Slack's
    // webhook parser reliably accepts. mode:'no-cors' keeps the (opaque)
    // response from throwing; the download proceeds regardless.
    fetch(WEBHOOK_URL, {
      method: 'POST',
      mode: 'no-cors',
      body: new URLSearchParams({ payload: JSON.stringify(payload) }),
      keepalive: true,
    }).catch(() => {});
  } catch (err) {
    // Never let notification failures interfere with the download.
  }
};
